import axios from 'axios';

// 创建 axios 实例
const api = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.VUE_APP_BASE_API : '/api',
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// 请求拦截器
api.interceptors.request.use(
  config => {
    // 在生产环境中确保使用 HTTPS
    if (process.env.NODE_ENV === 'production' && config.baseURL) {
      config.baseURL = config.baseURL.replace('http://', 'https://');
    }
    
    // 可以在这里添加认证 token 等
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

// 响应拦截器
api.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    console.error('API Error:', error);
    
    // 在生产环境中添加降级处理
    if (process.env.NODE_ENV === 'production') {
      if (error.response && error.response.status === 502) {
        console.warn('API 服务不可用，使用降级处理');
        // 可以在这里添加降级逻辑
      } else if (!error.response) {
        console.warn('网络连接失败，可能是代理配置问题');
      }
    }
    
    return Promise.reject(error);
  }
);

export default api;